import { Either, left } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class RedeemsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async filterRedeems(params: {
    partners: string[];
    name: string;
    page: number;
    limit: number;
  }): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/redeems/filter`,
      params: {
        partners: params.partners,
        name: params.name,
        page: params.page,
        limit: params.limit,
      },
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async getRedeems(
    params?: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/redeems/all`,
      params,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async syncGiffty(): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/giffty/sync-giffty-redeems`,
    };
    const response = await this.api.request(request);

    if (response.statusCode === HttpTypes.HttpStatusCode.conflict) {
      const rawMessage = response.body?.message ?? response.body?.error ?? 'sync already running';
      const message = Array.isArray(rawMessage) ? rawMessage[0] : rawMessage;
      return left(new Error(message));
    }

    return httpResponseHandler(response);
  }
}
